/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetFreeeConnected200Response
 */
export interface GetFreeeConnected200Response {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'freeeCompanyName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'cardAccountUnit': GetFreeeConnected200ResponseCardAccountUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'connectedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeConnected200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'accountItemIdForPointUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'journalEntryTransitionModeEndDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'journalEntryStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'embedUrlMethod'?: GetFreeeConnected200ResponseEmbedUrlMethodEnum;
    /**
     * Type of synchronization with freee
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'syncType': GetFreeeConnected200ResponseSyncTypeEnum;
}

export const GetFreeeConnected200ResponseCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type GetFreeeConnected200ResponseCardAccountUnitEnum = typeof GetFreeeConnected200ResponseCardAccountUnitEnum[keyof typeof GetFreeeConnected200ResponseCardAccountUnitEnum];
export const GetFreeeConnected200ResponseEmbedUrlMethodEnum = {
    none: 'NONE',
    back: 'BACK',
    front: 'FRONT'
} as const;

export type GetFreeeConnected200ResponseEmbedUrlMethodEnum = typeof GetFreeeConnected200ResponseEmbedUrlMethodEnum[keyof typeof GetFreeeConnected200ResponseEmbedUrlMethodEnum];
export const GetFreeeConnected200ResponseSyncTypeEnum = {
    journalizeOnFreee: 'JOURNALIZE_ON_FREEE',
    journalizeOnUpsider: 'JOURNALIZE_ON_UPSIDER',
    composite: 'COMPOSITE'
} as const;

export type GetFreeeConnected200ResponseSyncTypeEnum = typeof GetFreeeConnected200ResponseSyncTypeEnum[keyof typeof GetFreeeConnected200ResponseSyncTypeEnum];


